<template>
    <div style="padding: 15px;" v-if="lang">
        <h3 class="dialog--title">{{ boxData ? 'Editar Solicitud de Box' : 'Solicitar Nuevo Box'}}</h3>
        <hr>
        <div class="col-sm-6">
            <p class="md-body-2 form-note"><strong>Importante:</strong> Todos los campos en <span class="color--red">*</span> son requeridos.</p>
        </div>
        <!-- <md-layout md-gutter class="register-doctor main--content"> -->
            <div class="col-md-12 col-sm-12 col-xs-12 no-padder">
                <form novalidate @submit.stop.prevent="submit">
                    <div style="padding: 0">
                        <div style="background: #fafafa;">
                        </div>
                        <div class="spacer"></div>
                        <div class="clearfix"></div>
                        <div class="bonus_container medibox" style=" width: 100%; float: left; background: rgba(234, 234, 234, 0.46);">
                            <div class="alert alert-info" style=" background: #00bcd4; color: white; padding: 10px; border-radius: 10px;">
                                MediBox
                            </div>
                            <div style="padding: 10px">
                                <md-layout md-gutter>
                                    <!-- <div class="alert alert-info" style="
                                        background: #8bc34a;
                                        color: white;
                                        padding: 10px;
                                        width:100%;
                                        margin-bottom: 20px;">
                                        Busqueda en proceso.
                                    </div> -->
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b style="    display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;"> Indique donde prefiere el Box</b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b>Nombre</b>
                                        <md-input-container style="margin-top: 1px;padding-top:1px !important;background: white;min-height: 35px;" :md-inline="false">
                                            <md-input :disabled="info_data.view === true ? true : false" v-model="form.name"></md-input>
                                        </md-input-container>
                                        <b>Correo Electrónico</b>
                                        <md-input-container style="margin-top: 1px;padding-top:1px !important;background: white;min-height: 35px;" :md-inline="false">
                                            <md-input :disabled="info_data.view === true ? true : false" v-model="form.email"></md-input>
                                        </md-input-container>
                                        <b>Teléfono</b>
                                        <md-input-container style="margin-top: 1px;padding-top:1px !important;background: white;min-height: 35px;" :md-inline="false">
                                            <md-input :disabled="info_data.view === true ? true : false" v-model="form.phone"></md-input>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b>Dirección</b>
                                        <md-input-container style="margin-top: 1px;padding-top:1px !important;background: white;min-height: 35px;" :md-inline="false">
                                            <md-input :disabled="info_data.view === true ? true : false" v-model="form.address"></md-input>
                                        </md-input-container>
                                         <template v-for="(image, i) in form.images">
                                            <b>Imagen</b>
                                            <md-input-container style="margin-top: 1px;padding-top:1px !important;background: white;min-height: 35px;">
                                                <md-file @selected="selectImage($event, i)" accept="image/*"></md-file>
                                            </md-input-container>
                                        </template>
                                        </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b>Provincia <span class="color--red">*</span></b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : errors.region_id =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                        <span v-if="info_data.view">
                                            {{info_data.region}}
                                        </span>
                                        <vue-select v-else
                                            :options="regions"
                                            placeholder="Provincia"
                                            v-validate
                                            required
                                            data-vv-name="region"
                                            :on-change="changeRegion"
                                            v-model="info_data.region"
                                            class="md-input select2"
                                            style="width: 100%;"
                                            >
                                            <span slot="no-options">No se encontraron resultados.</span>
                                        </vue-select>
                                        <span class="md-error">Provincia es requerido</span>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b>Comuna <span class="color--red">*</span></b>
                                    </md-layout>
                                        <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : errors.city_id =='' }" style="margin-top: 5px !important; margin-bottom: 27px;">
                                            <span v-if="info_data.view">
                                                {{info_data.city}}
                                            </span>
                                            <vue-select
                                                v-else
                                                :options="comunities"
                                                placeholder="Comuna"
                                                v-validate
                                                required
                                                data-vv-name="city"
                                                :on-change="changeCity"
                                                v-model="info_data.city"
                                                style="width: 100%;"
                                                class="md-input select2"
                                                :disabled="form.region_id == null"
                                                >
                                                <span slot="no-options">No se encontraron resultados.</span>
                                            </vue-select>
                                            <span class="md-error">Comuna es requerido</span>
                                        </md-layout>

                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b style="display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;">
                                            Indique el periodo de arriendo que desea
                                        </b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="">
                                        <b>Periodo <span class="color--red">*</span></b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' :errors.period =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                        <span v-if="info_data.view">
                                            {{info_data.period}}
                                        </span>
                                        <vue-select v-else
                                            :options="box_plans"
                                            v-validate
                                            required
                                            data-vv-name="box_plan"
                                            placeholder="Periodo de Arriendo"
                                            :on-change="changePeriod"
                                            v-model="info_data.period"
                                            class="md-input select2"
                                            style="width: 100%;"
                                            >
                                            <span slot="no-options">No se encontraron resultados.</span>
                                        </vue-select>
                                        <span class="md-error">Periodo de arriendo es requerido</span>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                    <b style="display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;">
                                        Indique Especialidad, Horarios y Precio
                                    </b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="">
                                        <b>Especialidad <span class="color--red">*</span></b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : errors.speciality_id =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                        <span v-if="info_data.view">
                                            {{info_data.special}}
                                        </span>
                                        <vue-select v-else
                                            :options="filteredSpecialities"
                                            placeholder="Especialidad"
                                            v-validate
                                            required
                                            data-vv-name="box_spe"
                                            :on-change="changeSpecialty"
                                            v-model="info_data.special"
                                            class="md-input select2"
                                            style="width: 100%;"
                                            >
                                            <span slot="no-options">No se encontraron resultados.</span>
                                        </vue-select>
                                        <span class="md-error">Especialidad es requerido</span>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : errors.price =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                        <div class="col-sm-6">
                                            <md-input-container >
                                                <label> Precio </label>
                                                <md-input
                                                    :disabled="info_data.view === true ? true : false"
                                                    v-model="form.price"
                                                    v-validate
                                                    data-vv-name="price"
                                                    data-vv-rules="required|numeric"
                                                    required
                                                ></md-input>
                                                <div class="marcaagua" data-v-44c3599e="">ej: 9999999</div>
                                            </md-input-container>
                                                <span class="md-error">Precio es requerido</span>
                                        </div>
                                                <span class="md-error">Precio es requerido</span>
                                        <br>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b>Horario Mañana</b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px !important;">
                                        <ul class="schedule_days">
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.monday[0]" id="my-test1" name="my-test-group1" md-value="1">Lunes</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.tuesday[0]" id="my-test1" name="my-test-group1" md-value="1">Martes</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.wednesday[0]" id="my-test1" name="my-test-group1" md-value="1">Miercoles</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.thursday[0]" id="my-test1" name="my-test-group1" md-value="1">Jueves</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.friday[0]" id="my-test1" name="my-test-group1" md-value="1">Viernes</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.saturday[0]" id="my-test1" name="my-test-group1" md-value="1">Sabado</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.sunday[0]" id="my-test1" name="my-test-group1" md-value="1">Domingo</md-checkbox>
                                            </li>
                                        </ul>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100">
                                        <b>Horario Tarde</b>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px !important;">
                                        <ul class="schedule_days">
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.monday[1]" id="my-test1" name="my-test-group1" md-value="1">Lunes</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.tuesday[1]" id="my-test1" name="my-test-group1" md-value="1">Martes</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.wednesday[1]" id="my-test1" name="my-test-group1" md-value="1">Miercoles</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.thursday[1]" id="my-test1" name="my-test-group1" md-value="1">Jueves</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.friday[1]" id="my-test1" name="my-test-group1" md-value="1">Viernes</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.saturday[1]" id="my-test1" name="my-test-group1" md-value="1">Sabado</md-checkbox>
                                            </li>
                                            <li>
                                                <md-checkbox :disabled="info_data.view === true ? true : false" v-model="form.schedule.sunday[1]" id="my-test1" name="my-test-group1" md-value="1">Domingo</md-checkbox>
                                            </li>
                                        </ul>
                                    </md-layout>

                                </md-layout>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                            <md-dialog-actions class="modal--footer">
                                <md-button style="padding: 0 15px;"
                                    class="float-l md-primary sm-size
                                    md-size btn--cancel" @click="closed()">
                                    {{info_data.view ? 'Cerrar' : translate.pages.office.edit.cancel}}
                                </md-button>
                                <md-button style="padding: 0 15px;"
                                    v-if="info_data.view != true"
                                    type="submit" class="float-r md-primary sm-size md-size btn--blue btn--save"
                                    :disabled="process || form.busy">
                                    {{translate.pages.office.edit.save}}
                                    </md-button>
                            </md-dialog-actions>
                    </div>
                </form>
            </div>
    </div>

</template>
<script>
    import Form from 'vform'
    const swal = require('sweetalert2');
    import VForm from 'vform'
    window.lock = false;
    var language = window.navigator.userLanguage || window.navigator.language;
    import { login, doctor, public_api } from '../../../config/api.js';
    import NumberInputSpinner from 'vue-number-input-spinner'
    import vueSelect from "vue-select";
    export default {
        props: {
            boxData: Object,
            infoData: Object
        },

        components: {
            vueSelect,
            NumberInputSpinner,
            VForm
        },
       created(){
            this.fillForm()
            this.fillInfo()
            this.getProvinciaRegion()
            self = this;
            var country = { "country": this.$route.params.country.toUpperCase() };
            this.$http.post(public_api.api.regions, country).then(response => {
                let data = response.data.data;
                data.map((item, index) => {
                    item.value = item.geonameId;
                    item.label = item.toponymName;
                });
                this.regions = data;
            }).catch(error => {
                //alert("No se pudo cargar las comunidades");
            });

            this.$http.get('/doctor/me', {
                headers: {
                    Authorization : 'Bearer '+ this.$auth.getToken(),
                }
                }).then(response => {
                    if(response.data.status == "OK"){
                        let data = response.data.data;
                        self.fbSynced = true;
                        if(data.facebook_id && data.facebook_token){
                            self.fbPageData = {
                                id: data.facebook_id,
                                token: data.facebook_token,
                                name: data.facebook_name
                            }
                            self.fbStatus = 3;
                        }
                        data.region = {'label':'','value':''};
                        data.city = {'label':'','value':''};
                        self.doctor = data;
                        // console.log("doc", data)
                        self.doctor.in_bon_particular = parseInt(data.bon_particular);
                        self.doctor.in_bon_fonasa = parseInt(data.bon_fonasa);
                        self.doctor.in_bon_isapre = parseInt(data.bon_isapre);
                        if(self.doctor.need_box){
                            self.box_data = JSON.parse(self.doctor.box_data)
                        }
                        if(self.doctor.image)
                        {
                            self.profile_image = self.doctor.image;
                        }else{
                            this.profile_image = 'https://api.agendaenlinea.cl/image/default_avatar.png';
                        }
                        if(self.doctor.is_institution){
                            var country = { "country": self.$route.params.country.toUpperCase() };
                            self.$http.post(doctor.api.regions, country, {
                                        headers: {
                                            Authorization : 'Bearer '+ self.$auth.getToken(),
                                        }
                                }).then(response => {
                                    let data = response.data.data;
                                    data.map((item, index) => {
                                        item.value = item.geonameId;
                                        item.label = item.toponymName;
                                        if(item.geonameId == self.doctor.region_id){
                                            self.doctor.region.label = item.toponymName;
                                            self.doctor.region.value = item.geonameId;
                                            self.$http.post(public_api.api.cities, {region: self.doctor.region.value})
                                                .then(response => {
                                                    let data = response.data.data;
                                                    data.map(_item => {
                                                        _item.value = _item.geonameId
                                                        _item.label = _item.toponymName
                                                        if(_item.toponymName == self.doctor.comunity){
                                                            self.doctor.city.label = _item.toponymName;
                                                            self.doctor.city.value = _item.geonameId;
                                                        }
                                                    })
                                                    self.cities = data;
                                                })
                                        }
                                    });
                                    // storage comunities
                                    self.regions = data;
                                }).catch(error => {
                                    // console.log(error);
                                    //alert("No se pudo cargar las comunidades");
                                });
                        }

                    }
                });
                self.$http.get('/specialities?country='+self.$route.params.country)
		                .then(response => {
		                    if(response.data.status == "OK"){
                                self.specialities = response.data.data;
                                // console.log("spes", self.specialities, JSON.stringify( self.specialities ))
		                        self.doctor.specialities.forEach( speciality => {
	                            self.specialities.find( _speciality  => {
	                                if (speciality.id == _speciality.id){
	                                    _speciality.checked = true;
	                                    return false;
	                                }
	                            	});
	                        	});
		                    }
		                });
        },
        watch: {
            boxData() {
                this.fillForm()
            },
            infoData() {
                this.fillInfo()
            }
        },
        data() {
            return {
                form: new Form ({
                    name: null,
                    email: null,
                    phone: null,
                    address: null,
                    images: [null, null, null, null, null, null],
                    speciality_id: null,
                    city_id: null,
                    region_id: null,
                    price: null,
                    period: null,
                    schedule: {
                        monday: [false, false],
                        tuesday: [false, false],
                        wednesday: [false, false],
                        thursday: [false, false],
                        friday: [false, false],
                        saturday: [false, false],
                        sunday: [false, false],
                    },
                }),
                info_data: {
                    period: null,
                    region: null,
                    city:  null,
                    special: null,
                    view: false
                },
                images1: null,
                images2: null,
                images3: null,
                box: [],
                pageOfItems: [],
                specialities: [{"id":"057C453A-17CD-4795-B8F4-5AB95110DFB9","name":"Anestesista","description":"Anestesista"},{"id":"3BDEC1AF-8647-4C6A-A08A-131DC4B8829D","name":"Oncologia","description":"Oncologia"},{"id":"45bd83b0-abaa-11e8-afdf-35d602ac8a32","name":"Chequeo Médico Integral","description":"Chequeo medico integral"},{"id":"45dc75e0-abaa-11e8-9c32-1324a6295ec7","name":"Chequeo Médico Cardiovascular","description":"Chequeo medico cardiovascular"},{"id":"45eae380-abaa-11e8-ac64-bb7ebbc278f0","name":"Chequeo Médico Deportivo","description":"Chequeo medico deportivo"},{"id":"45fad230-abaa-11e8-b076-8b52a9d6439e","name":"Chequeo Médico Adulto Mayor","description":"Chequeo medico adulto mayor"},{"id":"77932880-6fdd-11e7-b67d-bb361b4eeecc","name":"Acido hialurónico","description":"Acido hialurónico"},{"id":"7794a7d0-6fdd-11e7-abbf-a9732fe01a60","name":"Acondicionamiento físico","description":"Acondicionamiento físico"},{"id":"7798d460-6fdd-11e7-b115-7327dfe1750f","name":"Acupuntura","description":"Acupuntura"},{"id":"779a5710-6fdd-11e7-a77a-911eb1c6e196","name":"Alergias e inmunologia","description":"Alergias e inmunologia"},{"id":"779bbf60-6fdd-11e7-be04-111bff2849a9","name":"Alimentación sana","description":"Alimentación sana"},{"id":"779d3c40-6fdd-11e7-a514-75e53801da4e","name":"Anestesiologo","description":"Anestesiologo"},{"id":"77a02b60-6fdd-11e7-bd57-a5dc2a64b9fd","name":"Antroposofia","description":"Antroposofia"},{"id":"77a1c490-6fdd-11e7-b7dc-fb4ee0b67306","name":"Apiterapia","description":"Apiterapia"},{"id":"77a33db0-6fdd-11e7-b342-89e761d08f46","name":"Apto físico","description":"Apto físico"},{"id":"77a4b8e0-6fdd-11e7-8ba0-8b2f1aac249e","name":"Aromaterapia","description":"Aromaterapia"},{"id":"77a77780-6fdd-11e7-b6d1-c9cca78990e1","name":"Artes marciales","description":"Artes marciales"},{"id":"77a8fd00-6fdd-11e7-bd32-fb1d0f8a704a","name":"Artes orientales","description":"Artes orientales"},{"id":"77aa7a10-6fdd-11e7-aaf6-577e471485b1","name":"Arteterapia","description":"Arteterapia"},{"id":"77ac1730-6fdd-11e7-a4e7-17326d1f455f","name":"Audiometría","description":"Audiometría"},{"id":"77ad95e0-6fdd-11e7-9024-dd565bc9a658","name":"Auriculoterapia","description":"Auriculoterapia"},{"id":"77b01fe0-6fdd-11e7-9932-0d28d90810e9","name":"Ayuerveda","description":"Ayuerveda"},{"id":"77b1ad50-6fdd-11e7-bac8-7f6ec312a3eb","name":"Belleza corporal","description":"Belleza corporal"},{"id":"77b33480-6fdd-11e7-8897-9b63f59d6568","name":"Bienestar físico","description":"Bienestar físico"},{"id":"77b4c290-6fdd-11e7-9f4f-11379e5a5fb2","name":"Biodanza","description":"Biodanza"},{"id":"77b782d0-6fdd-11e7-8f19-2b2c2e0bd366","name":"Bioenergética","description":"Bioenergética"},{"id":"77b902e0-6fdd-11e7-be25-2728d4ea8f3c","name":"Biomagnetismo","description":"Biomagnetismo"},{"id":"77ba7040-6fdd-11e7-b71d-dbe758d94044","name":"Botox","description":"Botox"},{"id":"77bbdb90-6fdd-11e7-9246-91aac1e6466f","name":"Broncopulmonar","description":"Broncopulmonar"},{"id":"77bea7e0-6fdd-11e7-a048-43c16fc9ca53","name":"Cardiología","description":"Cardiología"},{"id":"77c03750-6fdd-11e7-b8b8-e5e3f45bd98b","name":"Cardiologia infantil","description":"Cardiologia infantil"},{"id":"77c1afd0-6fdd-11e7-b919-b3e6a0152e39","name":"Chequeo Medicina Interna","description":"Chequeo medicina interna"},{"id":"77c32540-6fdd-11e7-8e0d-8ddee50b3e49","name":"Chequeo Médico General","description":"Chequeo médico general"},{"id":"77c5f1f0-6fdd-11e7-bc61-3325b943ab29","name":"Cirugia abdominal digestiva","description":"Cirugia abdominal digestiva"},{"id":"77c76ab0-6fdd-11e7-9128-7149b8454469","name":"Cirugía amigdalas","description":"Cirugía amigdalas"},{"id":"77c8f9d0-6fdd-11e7-af70-9922988c4641","name":"Cirugía bariatrica","description":"Cirugía bariatrica"},{"id":"77ca8130-6fdd-11e7-87fd-b998cae36de1","name":"Cirugía cardiovascular","description":"Cirugía cardiovascular"},{"id":"77cbffd0-6fdd-11e7-9a2e-377d7b261b05","name":"Cirugía digestiva","description":"Cirugía digestiva"},{"id":"77cea0a0-6fdd-11e7-b36b-6fc28cfe1604","name":"Cirugía general","description":"Cirugía general"},{"id":"77d02180-6fdd-11e7-8a65-47ed058e21b7","name":"Cirugía hernias","description":"Cirugía hernias"},{"id":"77d1a0c0-6fdd-11e7-b60b-c177188f851a","name":"Cirugía plástica","description":"Cirugía plástica"},{"id":"77d33520-6fdd-11e7-a899-f371e6231132","name":"Cirujano bucal","description":"Cirujano bucal"},{"id":"77d5e950-6fdd-11e7-b6e9-e38d16ce17d1","name":"Clínica dental","description":"Clínica dental"},{"id":"77d803b0-6fdd-11e7-bb7f-c5f66fc62cba","name":"Crisis de ansiedad","description":"Crisis de ansiedad"},{"id":"77d98fd0-6fdd-11e7-b275-b15007f0d72a","name":"Crisis de pánico","description":"Crisis de pánico"},{"id":"77db1ad0-6fdd-11e7-99cb-f904a429401e","name":"Cromoterapia","description":"Cromoterapia"},{"id":"77dd1790-6fdd-11e7-9f87-75f8933ddd43","name":"Depilación","description":"Depilación"},{"id":"77de8e40-6fdd-11e7-acfc-f7af7ccf0b8c","name":"Depilación laser","description":"Depilación laser"},{"id":"77e01d40-6fdd-11e7-ade7-fbe995a209b6","name":"Depresión","description":"Depresión"},{"id":"77e1a510-6fdd-11e7-a4ee-e742b575cbca","name":"Dermatología","description":"Dermatología"},{"id":"77e46380-6fdd-11e7-a296-8dbd6dab57f1","name":"Digitopuntura","description":"Digitopuntura"},{"id":"77e5e7e0-6fdd-11e7-b134-fb97e2816ec5","name":"Drenaje linfático","description":"Drenaje linfático"},{"id":"77e76a90-6fdd-11e7-b659-136bad8a21ac","name":"E.f.t.","description":"E.f.t."},{"id":"77e8f2a0-6fdd-11e7-8cb0-ad0983cbfaec","name":"Ecocardiograma","description":"Ecocardiograma"},{"id":"77ea77d0-6fdd-11e7-9402-45786c46fdd2","name":"Ecografía","description":"Ecografía"},{"id":"77ed11d0-6fdd-11e7-8036-0f7db646dc24","name":"Ecotomografía","description":"Ecotomografía"},{"id":"77ee98a0-6fdd-11e7-a0a0-cb6c974653de","name":"Electro estimulación onda-h","description":"Electro estimulación onda-h"},{"id":"77f01aa0-6fdd-11e7-9e6f-57613d04dc5f","name":"Endo-pediatría","description":"Endo-pediatría"},{"id":"77f19eb0-6fdd-11e7-89d2-d3347149f92a","name":"Endocrinología","description":"Endocrinología"},{"id":"77f45b90-6fdd-11e7-b9fd-835919ce68f5","name":"Endoscopía","description":"Endoscopía"},{"id":"77f5de40-6fdd-11e7-9aa8-ed77f9261861","name":"Energía cuántica","description":"Energía cuántica"},{"id":"77f80780-6fdd-11e7-9d90-c7b1b4b8470d","name":"Energía gea","description":"Energía gea"},{"id":"77fb8780-6fdd-11e7-b680-cd21acbbef4b","name":"Energía universal","description":"Energía universal"},{"id":"77fd08f0-6fdd-11e7-82b4-0b23db9fb9d8","name":"Enfermería","description":"Enfermería"},{"id":"77feae40-6fdd-11e7-9680-6bef6dac9d56","name":"Estética","description":"Estética"},{"id":"78003c30-6fdd-11e7-ba17-6151bbc1830e","name":"Estetica corporal","description":"Estetica corporal"},{"id":"7802d130-6fdd-11e7-888f-bb07bdcb18b3","name":"Estetica facial","description":"Estetica facial"},{"id":"78045b20-6fdd-11e7-b713-abc8b5f94576","name":"Estimulacion temprana de infantes","description":"Estimulacion temprana de infantes"},{"id":"7805dde0-6fdd-11e7-af9b-53a987b5237a","name":"Fangoterapia","description":"Fangoterapia"},{"id":"78076620-6fdd-11e7-9827-1142bd7a2788","name":"Fin de una relación","description":"Fin de una relación"},{"id":"7808e9e0-6fdd-11e7-9cb4-09dc6f04c98b","name":"Fisiatría","description":"Fisiatría"},{"id":"780b8060-6fdd-11e7-9a3e-77b5b3ed9b80","name":"Fisioterapia y rehabilitación médica","description":"Fisioterapia y rehabilitación médica"},{"id":"780d0b30-6fdd-11e7-b3d3-5d6f7346db4c","name":"Fitoterapia","description":"Fitoterapia"},{"id":"780e8210-6fdd-11e7-8b16-0181011baa1b","name":"Flores de bach","description":"Flores de bach"},{"id":"78100f40-6fdd-11e7-8183-071aee178ea6","name":"Flores del mediterraneo","description":"Flores del mediterraneo"},{"id":"7812d450-6fdd-11e7-8ca5-c9e7d8075c51","name":"Flores venezolanas","description":"Flores venezolanas"},{"id":"781458a0-6fdd-11e7-a41e-6fd3dfda0a8d","name":"Fonoaudiología","description":"Fonoaudiología"},{"id":"7815dfa0-6fdd-11e7-8376-5bd03c671f55","name":"Gastroenterología","description":"Gastroenterología"},{"id":"78175b40-6fdd-11e7-95e5-81df92fc67bf","name":"Geriatría","description":"Geriatría"},{"id":"7819f2a0-6fdd-11e7-9f57-9f1e7045122f","name":"Gimnasio","description":"Gimnasio"},{"id":"781b8960-6fdd-11e7-9e59-b70e77cd819e","name":"Ginecología","description":"Ginecología"},{"id":"781d0ae0-6fdd-11e7-9959-7bac6d3e5374","name":"Ginecología y obstetricia","description":"Ginecología y obstetricia"},{"id":"781ea610-6fdd-11e7-8427-958cff3c464c","name":"Healing touch","description":"Healing touch"},{"id":"78213db0-6fdd-11e7-99b1-25f9a2c549b9","name":"Hipnodieta","description":"Hipnodieta"},{"id":"7822bf40-6fdd-11e7-ad3d-05a8f7d15dba","name":"Homeopatía","description":"Homeopatía"},{"id":"78244340-6fdd-11e7-a0fe-a963aca4978e","name":"Hospitalización e imq","description":"Hospitalización e imq"},{"id":"7825d080-6fdd-11e7-ac78-4ba62fdbe12d","name":"Ideología eckista","description":"Ideología eckista"},{"id":"78275500-6fdd-11e7-bd40-f3c3d0ae1c00","name":"Imagenología","description":"Imagenología"},{"id":"7829e5e0-6fdd-11e7-8c44-5d14f5e1a5bd","name":"Implantes dentales","description":"Implantes dentales"},{"id":"782b6ec0-6fdd-11e7-b242-059767ac3ddf","name":"Infectología","description":"Infectología"},{"id":"782cfc80-6fdd-11e7-813c-77a2d3df51a5","name":"Insumos medicos","description":"Insumos medicos"},{"id":"782e7a90-6fdd-11e7-8827-470dd52f81ce","name":"Integración sensorial","description":"Integración sensorial"},{"id":"78313330-6fdd-11e7-9a41-7590c4c02048","name":"Iriología","description":"Iriología"},{"id":"78324850-6fdd-11e7-a7f9-235cab463cda","name":"Karate","description":"Karate"},{"id":"783367e0-6fdd-11e7-9a1f-0d418a1fa403","name":"Kinesiología","description":"Kinesiología"},{"id":"78349710-6fdd-11e7-9803-0595c06816bd","name":"Laboratorio clínico","description":"Laboratorio clínico"},{"id":"78363bf0-6fdd-11e7-9b1c-e927ac16bd19","name":"Laboratorio dental","description":"Laboratorio dental"},{"id":"78386940-6fdd-11e7-824a-8b43d1372eb9","name":"Magnetoterapia","description":"Magnetoterapia"},{"id":"783a0d10-6fdd-11e7-89ab-b701c2afc1e8","name":"Manicure","description":"Manicure"},{"id":"783bab40-6fdd-11e7-b887-49f23cc8e57a","name":"Manucupuntura","description":"Manucupuntura"},{"id":"783d3790-6fdd-11e7-bc45-8d0a5fe3ccf4","name":"Masaje de relajación","description":"Masaje de relajación"},{"id":"783e72e0-6fdd-11e7-92ad-95b05479464c","name":"Masaje deportivo","description":"Masaje deportivo"},{"id":"7840d780-6fdd-11e7-9694-a33f2f17ddf7","name":"Masaje facial","description":"Masaje facial"},{"id":"784207c0-6fdd-11e7-86ef-274bed093b15","name":"Masaje integral","description":"Masaje integral"},{"id":"78439470-6fdd-11e7-b7b8-09f431fd9059","name":"Masaje reductivo","description":"Masaje reductivo"},{"id":"78453420-6fdd-11e7-b80d-0f1f2e3693dd","name":"Masaje relajación","description":"Masaje relajación"},{"id":"7847a200-6fdd-11e7-997e-dd59e8852aca","name":"Masaje tailandes","description":"Masaje tailandes"},{"id":"78492600-6fdd-11e7-a9b7-93ca6ebabbc4","name":"Masaje terapéutico","description":"Masaje terapéutico"},{"id":"784aa960-6fdd-11e7-b782-2788b73d3112","name":"Masajes","description":"Masajes"},{"id":"784c4180-6fdd-11e7-976f-898b13e0bf92","name":"Masoterapia","description":"Masoterapia"},{"id":"784e08a0-6fdd-11e7-ae1c-9105dac7b5dc","name":"Matronas","description":"Matronas"},{"id":"785009b0-6fdd-11e7-aa0d-ddd95c4f8b19","name":"Medicina alternativa","description":"Medicina alternativa"},{"id":"78512db0-6fdd-11e7-bf86-d77b25d1274d","name":"Medicina deportiva","description":"Medicina deportiva"},{"id":"7852b6e0-6fdd-11e7-b77c-fd116c91b052","name":"Medicina estética","description":"Medicina estética"},{"id":"7853e410-6fdd-11e7-afed-29f80aeb3f4c","name":"Medicina familiar","description":"Medicina familiar"},{"id":"78550330-6fdd-11e7-b90e-91869cf6d75c","name":"Medicina general","description":"Medicina general"},{"id":"7857a900-6fdd-11e7-a334-dd45a4fb7fcb","name":"Medicina integral","description":"Medicina integral"},{"id":"78592a10-6fdd-11e7-a986-b7b615989b22","name":"Medicina interna","description":"Medicina interna"},{"id":"785ab780-6fdd-11e7-896d-ff1720eb9995","name":"Medicina natural","description":"Medicina natural"},{"id":"785c4070-6fdd-11e7-86a7-cfbb3d4f4803","name":"Medicina nuclear","description":"Medicina nuclear"},{"id":"785e80b0-6fdd-11e7-95eb-210d51b480ba","name":"Medicina tibetana","description":"Medicina tibetana"},{"id":"78601380-6fdd-11e7-813e-05a7f70ee6cb","name":"Médicos a domicilio","description":"Médicos a domicilio"},{"id":"78619c60-6fdd-11e7-a1f0-cf9aaad0b76b","name":"Musicoterapia","description":"Musicoterapia"},{"id":"78631fa0-6fdd-11e7-9e13-d1126f4e6b77","name":"Naturopatía","description":"Naturopatía"},{"id":"78644220-6fdd-11e7-a0ab-4120f1a222f9","name":"Nefrología","description":"Nefrología"},{"id":"7866cd40-6fdd-11e7-a99e-ef12a6b17235","name":"Neonatología","description":"Neonatología"},{"id":"7867ed30-6fdd-11e7-9643-db2d17ad9b15","name":"Neumología","description":"Neumología"},{"id":"78691a90-6fdd-11e7-8bd2-af68b240c003","name":"Neurocirugía","description":"Neurocirugía"},{"id":"786a4cf0-6fdd-11e7-86f5-4bf1775aede5","name":"Neurología","description":"Neurología"},{"id":"786bbca0-6fdd-11e7-b51f-9bf0e0999632","name":"Neuropediatría","description":"Neuropediatría"},{"id":"786e22d0-6fdd-11e7-96d5-891249ef8df9","name":"Nutrición","description":"Nutrición"},{"id":"786f4e20-6fdd-11e7-9379-0b9ff084f04a","name":"Nutricionista","description":"Nutricionista"},{"id":"787068a0-6fdd-11e7-a5b7-99bb9eb0efd8","name":"Nutriología","description":"Nutriología"},{"id":"7871af90-6fdd-11e7-9701-cf9e99f3ee33","name":"Odontología cirugía maxilar","description":"Odontología cirugía maxilar"},{"id":"78735520-6fdd-11e7-9030-f394b1defb55","name":"Odontología endodoncia","description":"Odontología endodoncia"},{"id":"78760ad0-6fdd-11e7-a30a-172213dcdd04","name":"Odontología estética","description":"Odontología estética"},{"id":"78772ea0-6fdd-11e7-a3cf-9b3447f2e2a9","name":"Odontología general","description":"Odontología general"},{"id":"7878b3d0-6fdd-11e7-aa9e-d1a6222c18cd","name":"Odontología implantes dentales","description":"Odontología implantes dentales"},{"id":"787a2910-6fdd-11e7-8fa1-bf6788022476","name":"Odontología implantología","description":"Odontología implantología"},{"id":"787b55d0-6fdd-11e7-b848-41dc33546a57","name":"Odontología maxilofacial","description":"Odontología maxilofacial"},{"id":"787dfb10-6fdd-11e7-97d4-919d0dc6d125","name":"Odontología operatoria","description":"Odontología operatoria"},{"id":"787f7680-6fdd-11e7-8ebf-355cc2256b36","name":"Odontología ortodoncia","description":"Odontología ortodoncia"},{"id":"7880f9c0-6fdd-11e7-9564-a1e17e9512a1","name":"Odontología periodoncia","description":"Odontología periodoncia"},{"id":"78828d10-6fdd-11e7-a61e-71bc44747c7d","name":"Odontología prótesis dentales","description":"Odontología prótesis dentales"},{"id":"78855d10-6fdd-11e7-b329-6543b99c4321","name":"Odontología radiología","description":"Odontología radiología"},{"id":"7886e600-6fdd-11e7-b17e-7f59d1b29be1","name":"Odontología rehabilitación dental","description":"Odontología rehabilitación dental"},{"id":"78886dc0-6fdd-11e7-af40-1164ad63dd5a","name":"Odontopediatría","description":"Odontopediatría"},{"id":"788a73a0-6fdd-11e7-b027-05ce6068dc8a","name":"Oftalmología","description":"Oftalmología"},{"id":"788c3cb0-6fdd-11e7-b898-cb18e52b329d","name":"Optica","description":"Optica"},{"id":"788ddcc0-6fdd-11e7-abc4-937c927b95b0","name":"Ortopedia","description":"Ortopedia"},{"id":"788f5930-6fdd-11e7-a7d3-8345dfa08d39","name":"Otorrinolaringología","description":"Otorrinolaringología"},{"id":"7893d550-6fdd-11e7-9998-5dfcca117100","name":"Otras","description":"Otras"},{"id":"78956d70-6fdd-11e7-9e9e-b1ae6c7c81ca","name":"Otras prestaciones","description":"Otras prestaciones"},{"id":"7896e1a0-6fdd-11e7-b237-11bc03ef4401","name":"Otro (diga cual)","description":"Otro (diga cual)"},{"id":"78989dd0-6fdd-11e7-a82a-113de7915a76","name":"Pánico escénico","description":"Pánico escénico"},{"id":"789a0cb0-6fdd-11e7-9abb-e1ba2046bfd0","name":"Pediatría","description":"Pediatría"},{"id":"789c4980-6fdd-11e7-95e2-a7b4b50a857b","name":"Pedicure","description":"Pedicure"},{"id":"789dc190-6fdd-11e7-9462-712168ebca73","name":"Pilates","description":"Pilates"},{"id":"789f50d0-6fdd-11e7-abe5-4908dc2cb7cd","name":"Podología","description":"Podología"},{"id":"78a0d860-6fdd-11e7-b646-4d4c541fdec7","name":"Prótesis dentales","description":"Prótesis dentales"},{"id":"78a3d780-6fdd-11e7-97d6-ad2a643c8a50","name":"Psicología","description":"Psicología"},{"id":"78a548b0-6fdd-11e7-b22a-438fd9ff7214","name":"Psicología-otro","description":"Psicología-otro"},{"id":"78a6ada0-6fdd-11e7-96f7-4dfe9d292960","name":"Psiquiatría","description":"Psiquiatría"},{"id":"78a82180-6fdd-11e7-b68f-35500c1224a8","name":"Quiropraxia","description":"Quiropraxia"},{"id":"78aab680-6fdd-11e7-be89-a3c783af607b","name":"Radiestesia","description":"Radiestesia"},{"id":"78ac3820-6fdd-11e7-828f-67d32a3d44c8","name":"Radiología","description":"Radiología"},{"id":"78adb070-6fdd-11e7-9c3b-13c603c51069","name":"Radiología dental","description":"Radiología dental"},{"id":"78af1770-6fdd-11e7-b6d9-2f4beb78d2f3","name":"Reflexología","description":"Reflexología"},{"id":"78b249d0-6fdd-11e7-9ea2-65734b7250c5","name":"Regresion-hipnosis","description":"Regresion-hipnosis"},{"id":"78b3daa0-6fdd-11e7-9788-879163685840","name":"Rehabilitación dental","description":"Rehabilitación dental"},{"id":"78b57310-6fdd-11e7-8102-a9c9c2cb1e37","name":"Reiki","description":"Reiki"},{"id":"78b6e0c0-6fdd-11e7-98cc-379c487b8f0e","name":"Reumatología","description":"Reumatología"},{"id":"78b87540-6fdd-11e7-b955-5f00c81c1ce4","name":"Sanación crística","description":"Sanación crística"},{"id":"78babac0-6fdd-11e7-8f29-31e4ec08f86f","name":"Sanación cuántica","description":"Sanación cuántica"},{"id":"78bc15a0-6fdd-11e7-972f-13bf63651f03","name":"Sanación energética del aura","description":"Sanación energética del aura"},{"id":"78bd8890-6fdd-11e7-bec3-a7bfddf36768","name":"Sauna","description":"Sauna"},{"id":"78bef3c0-6fdd-11e7-8220-dd875d55429c","name":"Scanner","description":"Scanner"},{"id":"78c238c0-6fdd-11e7-98a5-839d3fbb99ff","name":"Shiatsu","description":"Shiatsu"},{"id":"78c3c010-6fdd-11e7-a89c-ebf6f14b60c4","name":"Sicopedagogía","description":"Sicopedagogía"},{"id":"78c575d0-6fdd-11e7-90e5-83c101daeb59","name":"Sintergetica","description":"Sintergetica"},{"id":"78c998d0-6fdd-11e7-a1ad-93f3170e9375","name":"Sol pleno","description":"Sol pleno"},{"id":"78cb1860-6fdd-11e7-8597-21a94e532669","name":"Spa","description":"Spa"},{"id":"78cd0190-6fdd-11e7-bac3-d3d62cb38884","name":"Spa manos","description":"Spa manos"},{"id":"78cec9a0-6fdd-11e7-8f49-4b848ac7cffb","name":"Spa pies","description":"Spa pies"},{"id":"78d0db00-6fdd-11e7-a810-835f52517f89","name":"Tabaquismo","description":"Tabaquismo"},{"id":"78d28b60-6fdd-11e7-9255-c364a807c649","name":"Taekwondo","description":"Taekwondo"},{"id":"78d41840-6fdd-11e7-98b1-1107d3e4306a","name":"Taichi","description":"Taichi"},{"id":"78d59670-6fdd-11e7-a3ea-5360f484bda4","name":"Técnica metamorfica, terapia floral","description":"Técnica metamorfica, terapia floral"},{"id":"78d812e0-6fdd-11e7-bf65-9b31a43e28db","name":"Terapeutas ocupacionales","description":"Terapeutas ocupacionales"},{"id":"78d9a190-6fdd-11e7-ac35-495f3d77e9ab","name":"Terapia conflicto pareja","description":"Terapia conflicto pareja"},{"id":"78db48e0-6fdd-11e7-9713-99c50a4a76c9","name":"Terapia neural","description":"Terapia neural"},{"id":"78dcf6c0-6fdd-11e7-b23d-5bf50d0db23e","name":"Terapia sacro cranial","description":"Terapia sacro cranial"},{"id":"78de7d30-6fdd-11e7-b14d-69a876b27b86","name":"Terapia transpersonal","description":"Terapia transpersonal"},{"id":"78e0c570-6fdd-11e7-96e3-136bbd6de0f7","name":"Terapia universal","description":"Terapia universal"},{"id":"78e26120-6fdd-11e7-baac-0735c9c51d2e","name":"Terapias alternativas","description":"Terapias alternativas"},{"id":"78e3eee0-6fdd-11e7-8f6e-1b936084eee1","name":"Terapias complementarias","description":"Terapias complementarias"},{"id":"78e5a570-6fdd-11e7-89ac-61cb54124af4","name":"Terapias florales","description":"Terapias florales"},{"id":"78e814e0-6fdd-11e7-8457-854e5736a262","name":"Test de esfuerzo","description":"Test de esfuerzo"},{"id":"78e99e40-6fdd-11e7-9ec2-2b3f9091fe62","name":"Toxina botulínica","description":"Toxina botulínica"},{"id":"78eb39e0-6fdd-11e7-94ff-7b57a1adf4c0","name":"Tratamiento de sobrepeso","description":"Tratamiento de sobrepeso"},{"id":"78eca7d0-6fdd-11e7-86f3-a3ab2cb67f94","name":"Tratamientos corporales","description":"Tratamientos corporales"},{"id":"78ef2150-6fdd-11e7-8504-81b90c02b911","name":"Tratamientos reductivos","description":"Tratamientos reductivos"},{"id":"78f09780-6fdd-11e7-bc5d-ebac7ea19d57","name":"Traumatología","description":"Traumatología"},{"id":"78f21e80-6fdd-11e7-ac8d-fbcc53e7c72d","name":"Tuina","description":"Tuina"},{"id":"78f3ae10-6fdd-11e7-941f-dba288d8df3f","name":"Urgencia","description":"Urgencia"},{"id":"78f68830-6fdd-11e7-8ea7-71e87ca005a6","name":"Urología","description":"Urología"},{"id":"78f80f20-6fdd-11e7-a3c0-a7d699f4d153","name":"Uvaterapia","description":"Uvaterapia"},{"id":"78f992b0-6fdd-11e7-978e-ad466be3ca88","name":"Watsu","description":"Watsu"},{"id":"78fb1c50-6fdd-11e7-a876-7baeb75a2d11","name":"Yoga","description":"Yoga"},{"id":"CD6FF037-8368-403D-8067-6C2787DDFCCF","name":"Coaching","description":"Coaching"}],
                comunities: [],
                provincia_region: 'Región',
                radio1: null,
                radio2: null,
                radio3: null,
                radio4: null,
                radio5: null,
                radio6: null,
                radio7: null,
                radio8: null,
                radio9: null,
                radio10: null,
                radio11: null,
                radio12: null,
                radio13: null,
                radio14: null,
                regions: [],
                hours: [
                    {label: "Mañana", value: 0},
                    {label: "Tarde", value: 1}
                ],
                box_plans: [
                    {label: "Mensual: AM y PM", value: 'monthly_full'},
                    {label: "Mensual: 1/2 día AM o PM", value: 'monthly_partial'}
                ],
                box_data: {
                    "box_schedule":{
                        "lunes":[false,false],
                        "martes":[false,false],
                        "miercoles":[false,false],
                        "jueves":[false,false],
                        "viernes":[false,false],
                        "sabado":[false,false],
                        "domingo":[false,false]
                    },
                    "box_plan":{
                        // label: '',
                        // value: ''
                        "label":{
                            "label":{
                                label: '',
                                value: ''
                            },
                            value: ''
                        },
                        "value":""
                    },
                    "box_speciality":{
                        "label":"-----",
                        "value":"057C453A-17CD-4795-B8F4-5AB95110DFB9"
                    },
                    "box_region":{
                        "label":"-----",
                        "value":3871332
                    },
                    "box_city":{
                        "label":"-----",
                        "value":8261414
                    }
                },
                filterSpecialities: "",
                appID: '1954146001278287',

                fbSignInParams: {},
                fbLoged: false,
                fbPages: [],
                fbStatus: 0,
                fbPageData: {},
                fbWorking: false,
                fbSynced: false,

                process: false,
                language: 'es',
                alert: {
                    msg : '',
                },
                prefix: this.$route.params.country.toUpperCase(),
                doctor : {
                    code : '',
                    name : '',
                    lastname : '',
                    lastname2 : '',
                    email : '',
                    phone : '',
                    password : '',
                    password_confirmation : '',
                    notification_appointment : false,
                    notification_mail : false,
                    notification_sms : false,
                    type: 'doctor',
                    specialities: [],
                    region: {label:'',value:''},
                    city: {label:'',value:''},
                    bon_particular: 1,
                    bon_fonasa: 1,
                    bon_isapre: 1
                },
                regions: [],
                cities: [],
                profile_image: 'https://api.agendaenlinea.cl/image/default_avatar.png',
                data: {
                    listspecialities : [],
                    confirmation : {
                        isSuccess : false,
                        isError : false,
                    },
                    'region_id': '',
                    'region': { label: '', value: '' },
                    'comunity_id': '',
                    'city': { label: '', value: '' },
                    'specialty_id': '',
                    'specialty': { label: '',label2: "", value: '' },
                    'hour_type': 0,
                    'hour': { label: '', value: '' },
                    'box_plan': { label: '', value: '' },
                },
                errors:{
                    city_id: null,
                    period: null,
                    price: null,
                    region_id: null,
                    speciality_id: null
                },
                route: {
                    doctor: doctor,
                },
                datatable: {
                    sales_total: 0,
                    sales_usd_total: 0,
                    filters: {
                        search: {
                            query: '',
                            queryIsDirty: false,
                            isCalculating: false,
                            isQuery: false
                        },
                        visible: false,
                        rows: [
                            { value: 10, label: 'Mostrar 10' },
                            { value: 20, label: 'Mostrar 20' },
                            { value: 50, label: 'Mostrar 50' },
                            { value: 100, label: 'Mostrar 100' },
                            { value: 150, label: 'Mostrar 150' },
                            { value: 200, label: 'Mostrar 200' },
                            { value: 250, label: 'Mostrar 250' },
                            { value: 300, label: 'Mostrar 300' },
                        ],
                        row_selected: 50,
                        orderBy: [
                            { value: '0', label: 'Ordenar Por' },
                            { value: 'name', label: 'Nombre' },
                            { value: 'rut', label: 'Rut' },
                            { value: 'country', label: 'País' },
                        ],
                        countries: [],
                        provinces: [],
                        comunities: [],
                        patient_types: [],
                        previsions: [],
                        boxes: [],
                        ages: [],
                        options: {
                            limit: 10,
                            country: "-1",
                            sales: "-1",
                            is_supervisor: "-1",
                            orderby: "-1",
                            status: "-1",
                            group: '-1'
                        },
                        pages: {
                            last_page: null,
                            current_page: 1,
                            first_page: 1,
                            next_page_url: '',
                            prev_page_url: ''
                        }
                    },
                    total: {
                        reserves: [],
                        diaries: [],
                        prices: [],
                        discounts: [],
                        final_prices: []
                    }
                },
            }
        },
        computed: {
            filteredSpecialities(){
       			let self = this;
        		return this.specialities.filter(specialty => {
			      return specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0;
			    })
        	},
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            periodoInfo() {
                if(this.form.period == 'monthly_full')
                {
                    this.form.periodo_info = "Mensual: AM y PM"
                    // this.form.period = this.boxData.period
                } else if(this.form.period == 'monthly_partial'){
                    this.form.periodo_info = "Mensual: 1/2 día AM o PM"
                    // this.form.period = this.boxData.period
                }
                else {
                    this.form.periodo_info = null
                }
            },
            selectImage(event, i){
                this.form.images[i] = event[0]
            },
            changePeriod(info) {
                if(info){
                    if(typeof info != 'string'){
                        let period = this.box_plans.find(
                            item => {return item.id == info.id}
                        )
                        console.log(period.id)
                        this.form.period = period.value
                        this.errors.period = period.value
                            console.log("selec 2", period)
                    } else {
                        this.form.period = ''
                        this.errors.period = ''
                        return false;
                    }
                }else{
                        this.form.period = ''
                        this.errors.period = ''
                }
                // this.form.period = info.info
            },
            fillForm() {
                !
                this.boxData
                ?
                this.form.reset()
                :
                this.form.keys().forEach(key => this.form[key] = this.boxData[key])
            },
            fillInfo() {
                if(this.infoData) {
                    this.info_data = {
                        region : this.infoData.region,
                        special: this.infoData.special,
                        period: this.infoData.period,
                        city: this.infoData.city,
                        view: this.infoData.view
                    }
                } else {
                    this.info_data = {
                        region: null,
                        special: null,
                        city: null,
                        period: null,
                        view: false
                    }
                }
                // !
                // ? this.info_data.reset()
                // : this.info_data.keys().forEach(key => this.info_data[key] = this.infoData[key])

            },
            infoBoxes() {
                if(this.boxData) {
                    // this.form.speciality_id = this.boxData.speciality.name
                    // this.form.speciality = this.boxData.speciality.name
                    this.form.region = this.boxData.region.toponymName
                    this.info_data.city = this.boxData.city.toponymName
                    // this.form.speciality_id = this.boxData.speciality_id
                } else {
                    this.form.speciality = ''
                    this.form.region = ''
                    this.info_data.city = ''
                }
            },
            onChangePage(pageOfItems) {
                // update page of items
                this.pageOfItems = pageOfItems;
            },
            getProvinciaRegion(){
                if (this.$route.params.country == 'cl')
                    this.provincia_region = 'Región';
                else
                    this.provincia_region = 'Provincia';
            },
            get_doctor(){
            self = this;

            this.$http.get('/doctor/me', {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        let data = response.data.data;
                        self.fbSynced = true;
                        if(data.facebook_id && data.facebook_token){
                            self.fbPageData = {
                                id: data.facebook_id,
                                token: data.facebook_token,
                                name: data.facebook_name
                            }
                            self.fbStatus = 3;
                        }
                        data.region = {'label':'','value':''};
                        data.city = {'label':'','value':''};
                        self.doctor = data;
                        // console.log("doc", data)
                        self.doctor.in_bon_particular = parseInt(data.bon_particular);
                        self.doctor.in_bon_fonasa = parseInt(data.bon_fonasa);
                        self.doctor.in_bon_isapre = parseInt(data.bon_isapre);
                        if(self.doctor.need_box){
                            self.box_data = JSON.parse(self.doctor.box_data)
                        }
                        if(self.doctor.image)
                        {
                            self.profile_image = self.doctor.image;
                        }else{
                            this.profile_image = 'https://api.agendaenlinea.cl/image/default_avatar.png';
                        }
                        if(self.doctor.is_institution){
                            var country = { "country": self.$route.params.country.toUpperCase() };
                            self.$http.post(doctor.api.regions, country, {
                                        headers: {
                                            Authorization : 'Bearer '+ self.$auth.getToken(),
                                        }
                                }).then(response => {
                                    let data = response.data.data;
                                    data.map((item, index) => {
                                        item.value = item.geonameId;
                                        item.label = item.toponymName;
                                        if(item.geonameId == self.doctor.region_id){
                                            self.doctor.region.label = item.toponymName;
                                            self.doctor.region.value = item.geonameId;
                                            self.$http.post(public_api.api.cities, {region: self.doctor.region.value})
                                                .then(response => {
                                                    let data = response.data.data;
                                                    data.map(_item => {
                                                        _item.value = _item.geonameId
                                                        _item.label = _item.toponymName
                                                        if(_item.toponymName == self.doctor.comunity){
                                                            self.doctor.city.label = _item.toponymName;
                                                            self.doctor.city.value = _item.geonameId;
                                                        }
                                                    })
                                                    self.cities = data;
                                                })
                                        }
                                    });
                                    // storage comunities
                                    self.regions = data;
                                }).catch(error => {
                                    // console.log(error);
                                    //alert("No se pudo cargar las comunidades");
                                });
                        }
                    }
                });
            },
            resetSchedule(zone){
                if(zone == 1){
                    for (var index = 0; index < 8; index++) {
                            this["radio"+index] = null;
                    }
                } else {
                    for (var index = 8; index < 15; index++) {
                            this["radio"+index] = null;
                    }
                }
                this.dump_box();
            },
            changeRegion(value){
                if(value){
                    let region = this.regions.find(item => {
                        return item.geonameId == value.geonameId})
                    if(region){
                        this.form.region_id = region.value
                        this.errors.region_id = region.value
                        this.$http.post(public_api.api.cities, {region: this.form.region_id})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                })
                                this.comunities = data
                                this.form.city_id = ''
                                this.errors.city_id = ''
                                // this.data.city.value = ''
                            })
                    }
                }else{
                    this.comunities = []
                }
                this.getSpecialities();
            },
            // Change City
            changeCity(value) {
                if(value){
                    if(typeof value != 'string'){
                        let city = this.comunities.find(item => {
                            return item.geonameId == value.geonameId
                        })
                        this.form.city_id = city.value
                        this.errors.city_id = city.value
                        this.city = city.label
                    }
                }else{
                    this.form.city_id = ''
                    this.errors.city_id = ''
                }
                this.getSpecialities();
            },
            changeSpecialty(value) {
                if(value){
                    if(typeof value != 'string'){
                        let specialty = this.specialities.find(
                            item => {return item.id == value.id}
                        )
                        this.form.speciality_id = specialty.id
                        this.errors.speciality_id = specialty.id
                            // console.log("selec 2", specialty)
                    } else {
                        this.form.speciality_id = ''
                        this.errors.speciality_id = ''
                        return false;
                    }
                }else{
                        this.form.speciality_id = ''
                        this.errors.speciality_id = ''
                }
            },
            getSpecialities(){
               let url = doctor.speciality.list + '?country=' + this.$route.params.country + '&lang=es'
                this.$http.get(url)
                    .then(response => {
                        if(response.data.status == "OK"){
                            let data = response.data.data;
                            data.map((item, index) => {
                        item.value = item.id;
                        item.label = item.name;
                    });


                            this.specialities = data;
                        }
                    }).catch(error => {
                        // console.error("error de espes");
                        // console.log(error);
                    });
            },

            // Signin success
            renewPlan(){
                if(window.lock) return;
                window.lock = true;
                this.$http.post("https://api.agendaenlinea.cl/api/expresspayment/renew", {doctor_id: this.doctor.id}).then(function(data){

                if(data.data.status == 1) {
                        var form = document.createElement("form");
                        document.body.appendChild(form);
                        form.method = "POST";
                        form.action = "https://www.flow.cl/app/kpf/pago.php";
                        var element1 = document.createElement("INPUT");
                        element1.name="parameters"
                        element1.value = data.data.flowpay;
                        element1.type = 'hidden'
                        form.appendChild(element1);
                        form.submit();
                }
                window.lock = false;
                })
            },
            anualPlan(){
                if(window.lock) return;
            window.lock = true;
            this.$http.post("https://api.agendaenlinea.cl/api/expresspayment/anual", {doctor_id: this.doctor.id}).then(function(data){

                if(data.data.status == 1) {
                        var form = document.createElement("form");
                        document.body.appendChild(form);
                        form.method = "POST";
                        form.action = "https://www.flow.cl/app/kpf/pago.php";
                        var element1 = document.createElement("INPUT");
                        element1.name="parameters"
                        element1.value = data.data.flowpay;
                        element1.type = 'hidden'
                        form.appendChild(element1);
                        form.submit();
                }
                window.lock = false;
                })
            },
            onSignInSuccess (res) {
                var self = this;
                if(res.status == "connected"){
                    //this.fbStatus = 1;
                    //this.FacebookGetPages();
                    FB.ui({
                        method: 'pagetab',
                        redirect_uri: 'https://prestadores.agendaenlinea.cl/cl/profile'
                        }, function(response){
                            // console.log(response);
                            if( response.tabs_added && Object.keys(response.tabs_added).length == 1 ){
                                self.fbStatus = 5;
                            }
                        });
                }
            },
            // Facebook getPages
            FacebookGetPages(){
                var self = this;
                FB.api('/me/accounts', function (res) {
                    self.fbPages = res.data;
                    if(self.fbStatus == 3){
                        var found = false;
                        self.fbPages.forEach(function(v, index){
                            if(self.fbPages[index].id == self.fbPageData.id){
                                self.fbPageData.token = self.fbPages[index].access_token;
                                found = true;
                            }
                        })
                        if(found){
                            self.updateFacebookData();
                        } else {
                            self.removeFacebookData();
                        }
                    }
                    // console.log(res)
                });
            },
            // Select page from facebook
            FacebookSelectPage(page){
                if(this.fbWorking) return;
                this.fbPageData = {id:page.id, token: page.access_token, name: page.name};
                this.fbStatus = 2;
                // console.log(page);
            },
            // Crete tab to facebook
            FacebookCreateTab() {
                var self = this;
                if(self.fbWorking) return;
                self.fbWorking = true;
                var url = '/'+self.fbPageData.id+'/tabs';
                var data = {app_id: self.appID, access_token: self.fbPageData.token, position:1};
                FB.api(url, 'post', data, function (res) {
                    self.fbWorking = false;
                    if(res.success && res.success == true){
                        self.fbStatus = 3;
                        self.updateFacebookData();
                    } else {
                        self.fbStatus = 4;

                    }
                    // console.log(res);
                });
            },
            // Remove tab to facebook
            FacebookRemoveTab() {
                var self = this;
                if(self.fbWorking) return;
                self.fbWorking = true;
                var url = '/'+self.fbPageData.id+'/tabs';
                var data = {tab: 'app_'+self.appID, access_token: self.fbPageData.token};
                FB.api(url, 'delete', data, function (res) {
                    self.fbWorking = false;
                    if(res.success && res.success == true){
                        self.fbStatus = 0;
                        self.removeFacebookData();
                    } else {
                        self.fbStatus = 4;
                    }
                    // console.log(res);
                });
            },
            // Update facebook data
            updateFacebookData(){
                this.$http.post(doctor.api.facebook, this.fbPageData, {
                                headers: {
                                    Authorization : 'Bearer '+ this.$auth.getToken(),
                                }
                        }).then(response => {
                            let data = response.data.data;
                            // console.log(data)
                        })
            },
            // Remove facebook data
            removeFacebookData(){
                this.$http.delete(doctor.api.facebook, {
                                headers: {
                                    Authorization : 'Bearer '+ this.$auth.getToken(),
                                }
                        }).then(response => {
                            let data = response.data.data;
                            // console.log(data)
                        })
            },
            // Sngin error facebook
            onSignInError (error) {
                FB.ui({
                        method: 'pagetab',
                        redirect_uri: 'https://prestadores.agendaenlinea.cl/cl/profile'
                        }, function(response){
                            // console.log(response);
                        });
            //   console.log('OH NOES', error)
            },
            // Open Modal
            openDialog(ref) {
                this.$refs[ref].open();
            },
            // Close Modal
            closed(data = null) {
                this.info_data.region = null
                this.info_data.city = null
                this.info_data.speciality = null
                this.form.reset()
                this.$emit('closed', data);
            },
            // Send profile doctor
            async submit(){
                this.form.hasFiles = true

                if (this.form.speciality_id === '' && this.boxData) {
                    this.form.speciality_id = this.boxData.speciality_id
                }
                if (this.form.period === '' && this.boxData) {
                    this.form.period = this.boxData.period
                }

                let url = '/boxes/bids'

                if (this.boxData) {
                    this.form._method = 'PUT'
                    url += `/${this.boxData.id}`
                } else {
                    delete this.form._method
                }

                try {
                    const { data } = await this.form.post(url, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })

                    swal(this.boxData ? 'Actuaización exitosa' : 'Se Creado su solicitud con exito', '', 'success')

                    if (!this.boxData) {
                        this.info_data.region = null
                        this.info_data.city = null
                        this.info_data.speciality = null
                    }

                    this.errors  = {}
                    this.closed(data)
                } catch (e) {
                }
            },

            // Set errors form
            setErrors: function(data,){
                console.log('Error',data)
                for(let error in data)
                {
                    for(var index in data)
                    {
                        var messages = '';
                        data[index].forEach( function(item){ messages += item + ' '});
                        if(index == 'city_id' || index == 'period' || index == 'price' || index == 'region_id' || index == 'speciality_id')
                        {
                            this.errors[index] = '';
                        }else{
                            this._errors.errors.unshift({
                                field: index,
                                msg: messages,
                                // scope: scope
                            });
                        }
                    }
                }
            },
            // On chose by speciality
            onChosen(add, speciality_id){
                if(add){
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = true;
                        }
                    });
                    this.doctor.specialities.push({"id": speciality_id});
                }else{
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = false;
                        }
                    });
                    this.doctor.specialities.find( (speciality, index) => {
                        if (speciality.id == speciality_id){
                            this.doctor.specialities.splice(index,1);
                            return false;
                        }
                    });
                }
            },
            // Upload avatar
            uploadAvatarIcon(e){
                let icon = document.getElementById('fileAvatar');
                icon.click();
            },
            // Change avatar
            onAvatarChange(e) {
              this.errors.formAvatar = "";
              let formAvatar = document.getElementById('formAvatar');
            //   console.log(formAvatar);
              var weight = formAvatar.fileAvatar.files[0] ? ((formAvatar.fileAvatar.files[0].size / 1024) / 1024) : 0;
              if(weight >=1){
                this.errors.formAvatar = "Imagen pesa demasiado, limite 1MB";
                return;
              }
              let formData = new FormData(formAvatar);
              let url = this.route.doctor.api.upload.avatar;
              let self = this;
              this.process = true;
              this.$http.post(url, formData, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        this.process = false;
                        if(response.data.status == "OK"){
                            self.profile_image = response.data.data.image;

                        }else{
                            self.profile_image = "https://api.agendaenlinea.cl/image/default_avatar.png";
                        }
                        self.data.activeTab = 1;
                        self.$store.dispatch('setAvatar', self.profile_image);
                    }).catch(error => {
                        this.process = false;
                        // console.log("Catch");
                        if(error.response){
                            if(error.response.status = 422){
                                // this.setErrors(error.response.data);
                            }
                        }
                    });
            },
            // Change city
        }
    }

</script>
<style>
.medibox .md-layout.container.md-input-container.masked_input.md-input-invalid {
    padding-bottom: 0 !important;
    margin-bottom: 40px !important;
}

.medibox span.md-error {
    margin-left: 5px !important;
}

ul.schedule_days {
    list-style: none;
    padding: 0;
}

ul.schedule_days label.md-checkbox-label {
    position: initial;
}
ul.schedule_days li {
    display: inline-block;
    min-width: 110px;
    padding: 10px;
    background: #d2e6e8;
    overflow: hidden;
}
ul.schedule_days li:nth-child(odd) {
    background: #dbe0e0;
}

.bonus_container {
       margin-top:20px;
   }
.bonus_set {
    width: 33.33%;
    text-align: center;
    font-size: 20px;
    padding: 20px;
    float: left;
}
.bonus_set input {
    width: 100%;
    height: 30px;
    text-align:center
}

.bonus_set small {
    font-size: 10px;
    display: block;
}
.bonus_set:nth-child(3) {
    background-color: #f0efef;
}
.bonus_set:nth-child(4) {
    background-color: #e5e3e3b5;
}

@media (max-width:760px){
    .bonus_set {
    width: 100%;
    float: none !important;
    clear:both !important;
   }
   .bonus_container {
       height:auto !important;
       margin-top:20px;
   }
}
input.spin_input {-webkit-appearance: none;
    border: 1px solid #ebebeb;
    float: left;
    font-size: 16px;
    height: 40px !important;
    margin: 0;
    outline: none;
    text-align: center;
    width: calc(100% - 80px) !important;
}

button.spin_btn {
        -webkit-appearance: none;
    transition: background .5s ease;
    background: #387e90;
    border: 0;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    outline: none;
    width: 40px !important;
}
</style>
<style>
    @media (max-width: 380px) {
        .container {
            margin-left: 0em !important;
        }
        .md-dialog-actions{
            padding: 1px !important;
        }
        .md-dialog-content {
            padding: 0 8px 24px !important;
        }
    }
    @media (max-width: 500px) {

        .md-dialog-actions{
            padding: 1px !important;
        }
    }
    .btn--cancel {
        color: #ff0000b3 !important;
    }

    .btn--save {
        color: white !important;
    }
    .fb-signin-button {
        /* This is where you control how the button looks. Be creative! */
        display: inline-block;
        padding: 8px 8px;
        border-radius: 3px;
        background-color: #4267b2;
        background: url("../../../assets/img/facebook.png");
        color: #fff;
        cursor: pointer;
        width: 270px;
    height: 50px;

    }
    .fbintegration li.md-list-item {
        border: 0.5px solid #d2c9c9;
    }
    pre.code {
    background: whitesmoke;
    white-space: normal;
    padding: 20px;
}
    </style>
    <style lang="stylus">
    .v-select button.clear
        margin-top 6px
        color #ff0000b3 !important
    </style>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/boots.styl'
    @import '../../../assets/styles/common.styl'
    .multiple
        border 1px solid color_form_border
        border-radius 5px
        width 100%
        .title
            margin 0.5em
            color color_form_placeholder
        .select
            overflow-y scroll
            overflow-x hidden
            margin 0.25em
            height 110px
            .option
                width 95%
                margin 0.25em
    .subtitle
        margin-top .5em
        color color_form_placeholder
    .mar-top-1
        margin-top 1em
    .mar-top-2
        margin-top 2em
    .row
        margin 0
        padding .5em
    .v-select
        width 100% !important


    @import '../../../assets/styles/responsive.styl'
 .page-link
    color: #fff !important;
    background-color: #39b7c0;
    border-color: #39b7c0;

</style>



// WEBPACK FOOTER //
// EditBoxDoctor.vue?a5868f7a